import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

// Components
import Tooltip from './../utils/Tooltip'

// CSS
import './../../css/button.css'

// State
import { addToCart, clearSuccess } from './../../store/actions/cart'

// Utils (getInventory is safe for SSR)
import getInventory from '../../utils/inventoryUtils'

class ProductBuyBtn extends Component {
	constructor(props) {
		super(props)
		this.componentCleanup = this.componentCleanup.bind(this)
		this.state = {
			quantityError: false,
		}
	}

	componentDidMount() {
		window.addEventListener('beforeunload', this.componentCleanup)
	}

	componentWillUnmount() {
		this.componentCleanup()
	}

	componentCleanup() {
		this.props.clearSuccess()
		window.removeEventListener('beforeunload', this.componentCleanup)
	}

	addToCart() {
		if (this.checkInventoryQuantity()) {
			this.props.addToCart(this.props.product.id, this.props.quantity, this.props.variantsSelected)

			let categories = ''
			for (let i = 0; i < this.props.structure.length; i++) {
				if (categories !== '') {
					categories += '/'
				}
				categories += this.props.structure[i].title
			}

			const variant_title = isEmpty(this.props.variant)
				? ''
				: this.props.variant.sku_text.map(item => item.txt).join('/')

			const productData = {
				id: this.props.product.sku,
				name: this.props.product.title,
				category: categories,
				variant: variant_title,
			}

			console.log('Calling GA addToCart()', this.props)

			// ✅ SSR-SAFE: Import only on client
			if (typeof window !== 'undefined') {
				const { addToCart: addToCartGA } = require('../../utils/google-analytics')
				addToCartGA(productData, this.props.final_price, this.props.quantity, this.props.variant)
			}
		}
	}

	checkInventoryQuantity() {
		const inventory = getInventory(this.props.product, this.props.variant)
		const quantityEntered = parseInt(this.props.quantity, 10)
		const quantityInCartObj = this.props.items.find(item =>
			item.variant
				? item.variant.sku_id === (this.props.variant ? this.props.variant.id : this.props.variant)
				: item.product_id === this.props.product.id
		)
		const quantityCart = quantityInCartObj === undefined ? 0 : parseInt(quantityInCartObj.qty, 10)

		if (inventory === null || inventory === undefined) return this.hideQuantityTooltipError()

		if (quantityEntered <= inventory) {
			if (quantityInCartObj === undefined) return this.hideQuantityTooltipError()

			if (quantityEntered + quantityCart <= inventory) return this.hideQuantityTooltipError()
			else return this.showQuantityTooltipError()
		} else {
			return this.showQuantityTooltipError()
		}
	}

	showQuantityTooltipError() {
		this.props.clearSuccess()
		this.setState({ quantityError: true })
		return false
	}

	hideQuantityTooltipError() {
		this.setState({ quantityError: false })
		return true
	}

	render() {
		let inv = getInventory(this.props.product, this.props.variant)
		let disabled = inv > 0 || inv === undefined || inv === null ? false : true
		let btnText = inv > 0 || inv === undefined || inv === null ? 'Add to bag' : 'Out of stock'

		if (this.props.inProcess) {
			disabled = true
		}

		let showErrorTooltip = this.props.error !== undefined
		let showSuccessTooltip = this.props.success !== undefined
		let showQuantityError = {
			qty: `There is only ${getInventory(
				this.props.product,
				this.props.variant
			)} of this item currently in stock.`,
		}

		return (
			<div className='btn_container'>
				{this.state.quantityError && (
					<Tooltip parent={this.addBtn} type={'dialog--error'} messageObjects={showQuantityError} />
				)}
				<button
					className='btn buy_btn'
					ref={addBtn => (this.addBtn = addBtn)}
					disabled={disabled}
					onClick={() => this.addToCart()}
				>
					{btnText}
				</button>
				{showErrorTooltip && this.addBtn && (
					<Tooltip parent={this.addBtn} type={'dialog--error'} messageObjects={this.props.error} />
				)}
				{showSuccessTooltip && this.addBtn && (
					<Tooltip
						parent={this.addBtn}
						type={'dialog--success'}
						messageObjects={{ success: this.props.success }}
					/>
				)}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		items: state.cart.items,
		inProcess: state.cart.inProcess,
		error: state.cart.error,
		success: state.cart.success,
		variantsSelected: state.productVariant.variant_options,
		variant: state.productVariant.variant,
		final_price: state.product.final_price,
	}
}

export default connect(mapStateToProps, { addToCart, clearSuccess })(ProductBuyBtn)



// WEBPACK FOOTER //
// ./src/components/product/ProductBuyBtn.js